export class ArisMessageCodes {
    public static CUSTOMER_LOGGED_IN: number = 100;
    public static CUSTOMER_LOGGED_OUT: number = 101;    
    public static ESIGN_DOCUMENT_SIGNED: number = 300;
}
